import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/ApiEndpoints";
import Cookies from "js-cookie";

// Auth - Login
export const AuthLogin = createAsyncThunk(
  "auth/login/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth, data);
      console.log("AuthLogin Response:", res);
      
      return res;
    } catch (error) {
      
      return rejectWithValue(error.response.data);
    }
  }
);

// GET Auth - Login
export const GETAuthLogin = createAsyncThunk(
  "auth/login/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Auth);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetUserInfo = createAsyncThunk(
  "auth/GetUserInfo",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.UserInfo);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const AuthLogOut = createAsyncThunk(
  // Auth - Logout
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      // const res = await GET(APIS.Auth);
      Cookies.remove("driwe_admin_security", { path: "/" });
      return {
        data: {},
        token: null,
        role: null,
        permissions: null,
        isLogin: false,
        user_info: {},
        error: null,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const isTokenValid = createAsyncThunk(
  "auth/login/token-validation",
  async (_, { rejectWithValue }) => {
    try {
      const token = Cookies.get("driwe_admin_security");

      if (!token) return false;

      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        Cookies.remove("driwe_admin_security", { path: "/login" });
        return false;
      }

      return {
        data: {
          token,
          role: decodedToken.role,
          permissions: decodedToken.permissions,
        },
      };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "Token validation failed"
      );
    }
  }
);

export const Allpermissions = createAsyncThunk(
  "auth/admin-info",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.AdminInfo);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const Slice = createSlice({
  name: "auth",
  initialState: {
    data: {},
    token: null,
    role: null,
    permissions: null,
    isLogin: false,
    user_info: {},
    admin_info: [],
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(AuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.data.token;
        state.role = action.payload.data?.data?.role;
        state.permissions = action.payload.data?.data?.permissions;
        state.isLogin = true;
      })
      .addCase(AuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(GETAuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETAuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(GETAuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        // state.isLogin = false;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      //
      .addCase(AuthLogOut.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogOut.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      .addCase(AuthLogOut.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(isTokenValid.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(isTokenValid.fulfilled, (state, action) => {
        if (!action.payload) {
          state.status = IDS.SLICESTATUS.Failed;
          state.isLogin = false;
          return;
        }

        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.data.token;
        state.role = action.payload.data?.role;
        state.permissions = action.payload.data?.permissions;
        state.isLogin = true;
      })
      .addCase(isTokenValid.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(GetUserInfo.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetUserInfo.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.user_info = action.payload.data.data;
      })
      .addCase(GetUserInfo.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(Allpermissions.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Allpermissions.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.admin_info = action.payload.data.permissions;
      })
      .addCase(Allpermissions.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
